import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MainMenuItem, SubMenuItem } from '../main-menu';
import { PhitoSessionService } from '../../../services/phito-session.service';
import { MainMenuItemService } from './main-menu-item.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterService } from '../../../services/router.service';

@Component({
    selector: 'phito-main-menu-item',
    templateUrl: './main-menu-item.component.html',
    styleUrl: './main-menu-item.component.scss',
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        RouterModule,
        MatMenuModule,
    ],
})
export class MainMenuItemComponent implements OnInit {
    private phitoSessionService = inject(PhitoSessionService);
    private mainMenuItemService = inject(MainMenuItemService);
    private routerService = inject(RouterService);
    private rtr = inject(Router);

    @Input() mmi: MainMenuItem;
    @Input() isMenuNameVisible = true;
    @Output() navigated = new EventEmitter<boolean>();

    isMobileScreen: boolean;
    isActiveRoute: boolean;
    theOnlySubMenuItem: SubMenuItem;

    isMainMenuItemVisible: boolean = false;

    submenuItemPermissionMap = {};

    setActiveRoute() {
        this.isActiveRoute = this.mainMenuItemService.isActiveRoute(this.mmi);
    }

    ngOnInit(): void {
        for (const sub of this.mmi.subMenuItems) {
            const perm = this.phitoSessionService.hasPermission(
                sub.permission,
                'isMainMenuItemVisible',
            );
            this.submenuItemPermissionMap[sub.uuid] = perm;
            if (perm) {
                this.isMainMenuItemVisible = true;
            }
        }

        this.setActiveRoute();
        this.rtr.events.subscribe({
            next: () => {
                this.setActiveRoute();
            },
        });

        let subItem = undefined;
        for (const sub of this.mmi.subMenuItems) {
            if (this.phitoSessionService.hasPermission(sub.permission, 'MainMenuItemComponent')) {
                if (!subItem) {
                    subItem = sub;
                } else {
                    subItem = undefined;
                    break;
                }
            }
        }
        this.theOnlySubMenuItem = subItem;
        if (this.theOnlySubMenuItem && !this.theOnlySubMenuItem.iconName) {
            this.theOnlySubMenuItem.iconName = this.mmi.iconName;
            this.theOnlySubMenuItem.displayName = this.mmi.displayName;
        }
    }

    navigateMainMenu() {
        if (this.theOnlySubMenuItem) {
            this.routerService.nav(this.theOnlySubMenuItem.phitoRoute);
            this.navigated.next(true);
        }
    }

    navigateSubMenu(menuItem: SubMenuItem) {
        this.routerService.navSubMenu(menuItem);
        this.navigated.next(true);
    }
}
